import React from 'react';
import { Typography, TypographyColor } from '../../typography/typography';
import styles from '../add-to-cart-section.module.scss';
import { TextWithLabel } from './text-with-label';

// TODO: @Simon extract styles (currently uses add-to-cart-section styles)
type Props = {
  secondaryText: string;
  formattedAmount: string;
  formattedPrice: string;
  priceUnit: string;
  articleUnit: string;
  textColor?: TypographyColor;
};

// TODO: @Simon move and name properly
export const CartDecyphering: React.FC<Props> = ({
  secondaryText,
  formattedAmount,
  formattedPrice,
  priceUnit,
  articleUnit,
  textColor,
}) => {
  return (
    <div className={styles.textContainer}>
      <Typography color={textColor} variant="smalltext">
        {secondaryText}
      </Typography>
      <div className={styles.pricingContainer}>
        <TextWithLabel label={articleUnit} labelPosition="back">
          {formattedAmount}
        </TextWithLabel>
        <div className={styles.pricingDivider} />
        <TextWithLabel label={priceUnit} labelPosition="front">
          {formattedPrice}
        </TextWithLabel>
      </div>
    </div>
  );
};
